import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getHistory } from '../api/assessment';
import PageLayout from '../components/PageLayout';
import Card from '../components/Card';
import { clearAll as clearPendingReports } from '../utils/pendingReports';

// 四阶成熟度（L1→L4）统一走品牌蓝阶梯：从沉静的板岩蓝一路爬到完整的品牌深蓝，
// 阶位越高颜色越深，整页同色系不抢眼。兜底用次要文字色，杜绝再次出现「无样式裸文字」。
const GRADE_COLOR = {
  '初用期':'#5a6a8c', // L1
  '惯用期':'#3a66ab', // L2
  '扩散期':'#2a5699', // L3
  '重构期':'#1a3a6b', // L4 = 品牌主色
};
const gradeColor = (g) => GRADE_COLOR[g] || 'var(--color-text-secondary)';

export default function HistoryPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getHistory().then(({ data }) => setList(data)).catch(() => {}).finally(() => setLoading(false));
    // 进入历史记录页：清空顶导气泡（pending + ready 一起清）。
    clearPendingReports();
  }, []);

  return (
    <PageLayout>
      <style>{`
        .history-card{transition:box-shadow .18s ease, transform .18s ease, border-color .18s ease;}
        .history-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-2px);border-color:var(--color-primary-light);}
        .history-link:hover{background:var(--color-primary);color:#fff !important;}
        @media (prefers-reduced-motion: reduce){.history-card{transition:box-shadow .18s ease;}.history-card:hover{transform:none;}}
      `}</style>
      <div style={{maxWidth:720,margin:'0 auto',padding:'48px 20px'}}>
        <h1 style={{fontSize:24,fontWeight:700,marginBottom:8}}>历史测评记录</h1>
        <p style={{color:'var(--color-text-secondary)',marginBottom:32,fontSize:14}}>每次测评记录永久保留，不覆盖历史数据</p>
        {loading ? (
          <p style={{color:'var(--color-text-muted)'}}>加载中...</p>
        ) : list.length === 0 ? (
          <Card style={{textAlign:'center',padding:48}}>
            <p style={{color:'var(--color-text-muted)',marginBottom:24}}>暂无历史测评记录</p>
            <Link to="/assessment/rules" style={{color:'var(--color-secondary)',fontWeight:600}}>开始第一次测评 →</Link>
          </Card>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            {list.map(a => {
              const c = gradeColor(a.grade);
              const badgeBg = c.charAt(0) === '#' ? `${c}1a` : 'var(--color-primary-light)';
              return (
              <Card key={a.id} padding={20} className="history-card"
                style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:16}}>
                <div style={{display:'flex',alignItems:'center',gap:16,minWidth:0}}>
                  <div style={{display:'flex',flexDirection:'column',alignItems:'center',lineHeight:1,
                    minWidth:56,padding:'0 4px'}}>
                    <span style={{fontSize:26,fontWeight:800,color:'var(--color-primary)'}}>{a.score ?? '--'}</span>
                    <span style={{fontSize:12,color:'var(--color-text-muted)',marginTop:4}}>分</span>
                  </div>
                  <div style={{width:1,alignSelf:'stretch',background:'var(--color-border)'}} />
                  <div style={{minWidth:0}}>
                    {a.grade && (
                      <span style={{display:'inline-block',padding:'3px 12px',borderRadius:999,
                        fontSize:13,fontWeight:600,marginBottom:6,
                        background:badgeBg,color:c}}>
                        {a.grade}
                      </span>
                    )}
                    <div style={{fontSize:13,color:'var(--color-text-muted)'}}>
                      {new Date(a.completed_at).toLocaleString('zh-CN')} · {a.depth_display}
                    </div>
                  </div>
                </div>
                <Link to={'/report/v5/'+a.id} className="history-link" style={{
                  flexShrink:0,padding:'9px 18px',borderRadius:'var(--radius-sm)',fontSize:13,fontWeight:600,
                  background:'var(--color-primary-light)',color:'var(--color-primary)',
                  transition:'background .15s ease',
                }}>查看报告</Link>
              </Card>
              );
            })}
          </div>
        )}
      </div>
    </PageLayout>
  );
}
